import React from 'react';

export const ValidOrderIcon: React.FC = () => {
    return <span style={{paddingTop: '2px'}}>
        <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M7.16663 0C3.21065 0 0 3.21065 0 7.16663C0 11.1226 3.21065 14.3333 7.16663 14.3333C11.1226 14.3333 14.3333 11.1226 14.3333 7.16663C14.3333 3.21065 11.1226 0 7.16663 0ZM5.73343 10.75L2.15012 7.16666L3.16061 6.15616L5.73343 8.72181L11.1729 3.28235L12.1834 4.30001L5.73343 10.75Z" fill="#00A465" />
        </svg>
    </span>
}
